// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { actionsStyles } from "@cahaba/Overrides/Widgets/ProductList/ProductListActions";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

actionsStyles.addToCartWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
        margin-top: 10px;
        margin-bottom: -10px;
        margin-left: -25px;
        margin-right: -25px;
        button {
            border: none !important;
        }
        button:active,
        button:focus {
            border: 3px solid #09f !important;
            outline: none;
        }
    `,
};

actionsStyles.addToCartButton = {
    css: css`
        width: 100%;
        margin: 0 -1px -1px 0;
        font-size: 14px;
        text-transform: uppercase;
    `,
    typographyProps: {
        transform: "uppercase",
        size: 14,
        css: css`
            letter-spacing: 1px;
            font-size: 14px;
        `,
    },
};

actionsStyles.quantityOrdered = {
    cssOverrides: {
        formField: css`
            width: 5rem;
            min-width: 5rem;
            margin: 0 0 -1px -1px;
            label {
                display: none;
            }
            input {
                border: 1px solid ${getColor("common.border")} !important;
                text-align: center;
                font-weight: 700;
            }
            input:active,
            input:focus {
                border: 3px solid #09f !important;
                z-index: 2;
            }
        `,
    },
};

actionsStyles.productDetailsPriceText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
    size: 13,
    transform: "uppercase",
    weight: 700,
    color: "#2b2b2e",
};

actionsStyles.price = {
    price: {
        priceText: {
            color: "text.main",
            size: 20,
        },
    },
};

actionsStyles.addToCartButtonIcon = {
    color: "white",
    size: 10,
    css: css`
        margin-left: 7px;
        svg {
            fill: #ffffff;
        }
    `,
};
